import RtwImageType from "./actionTypes"



// function that called as action
const getListPage = data => ({
  type: RtwImageType.GET_RTW_IMAGE_PAGES,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getListPageSuccess = data => ({
  type: RtwImageType.GET_RTW_IMAGE_PAGES_SUCCESS,
  payload: data,
})

// function that called as action
const getDetail = (data, action) => ({
  type: RtwImageType.GET_DETAIL_RTW_IMAGE_BY_ID,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const getDetailSuccess = data => ({
  type: RtwImageType.GET_DETAIL_RTW_IMAGE_BY_ID_SUCCESS,
  payload: data,
})

// function that called as action
const postData = (data, action) => ({
  type: RtwImageType.POST_RTW_IMAGE,
  payload: data,
  action
})

// function to update state in reducer when fetching api is succeed or failed
const postDataSuccess = data => ({
  type: RtwImageType.POST_RTW_IMAGE_SUCCESS,
  payload: data,
})

// function that called as action
const putData = (data, action) => {
  return {
    type: RtwImageType.PUT_RTW_IMAGE,
    payload: data,
    action
  }
}

// function to update state in reducer when fetching api is succeed or failed
const putDataSuccess = data => ({
  type: RtwImageType.PUT_RTW_IMAGE_SUCCESS,
  payload: data,
})


const RtwImageAction = {
  getListPage,
  getListPageSuccess,


  getDetail,
  getDetailSuccess,


  postData,
  postDataSuccess,

  putData,
  putDataSuccess,

}

export default RtwImageAction





